<a class="news-list-card-container link-reset" [routerLink]="news().routerLink || news().url">
  <article class="news-list-card">
    <fstr-image
      class="news-list-card__image"
      [class.is--placeholder]="!news().image?.url"
      [image]="news().image || undefined"
      [width]="200"
      [height]="200"
      [colSpan]="{ sm: 2, lg: 3 }"
    ></fstr-image>

    <main class="news-list-card__main text-max-width-md">
      <div class="fs-body-xs d-flex gap-2 mb-2">
        <span class="text-primary flex-shrink-0">{{ news().publicationDate | newsDate }}</span>
        <span class="text-truncate">{{ news().subtitle }}</span>
      </div>
      <h3 class="h4 fw-semi max-lines-2 mb-max-lines news-list-card__title">{{ news().title }}</h3>
      @if (news().intro || news().text) {
        @if (news().intro) {
          <p class="news-list-card__text max-lines-3 text-max-width-sm">{{ news().intro | stripHtml }}</p>
        }
        @if (!news().intro && news().text) {
          <p class="news-list-card__text max-lines-3 text-max-width-sm">{{ news().text | stripHtml }}</p>
        }
      }
    </main>
  </article>
</a>
